<template>
  <div class="osk-product-comments-attached-imgs">
    <div
      v-for="img in images"
      :key="img.name"
      class="osk-product-comments-attached-imgs__item"
    >
      <div
        class="osk-product-comments-attached-imgs__item-remove"
        @click="() => handleImgRemove(img)"
      >
        <UikitIcon
          name="CloseCircle"
          size="s"
          color="white"
          class="osk-product-comments-attached-imgs__item-icon"
        />
      </div>

      <img
        :src="img.dataSrc"
        class="osk-product-comments-attached-imgs__image"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { IAttachedImg } from '~/types/components/attachedImages';

const props = defineProps<{
  attachedImgs: IAttachedImg[];
}>();

const emit = defineEmits<{
  (e: 'remove-img', file: IAttachedImg): void,
}>();

const images = ref<IAttachedImg[]>([]);

function handleImgRemove(img: IAttachedImg) {
  const currFile = props.attachedImgs.find((file) => img.name === file.name && img.size === file.size);

  images.value = images.value.filter((file) => img.name !== file.name && img.size !== file.size);

  if (!currFile) return;
  emit('remove-img', currFile);
}

watch(() => props.attachedImgs, () => {
  if (!props.attachedImgs.length) {
    images.value = [];
    return;
  }
  props.attachedImgs.forEach((img) => {
    const isFileAdded = images.value.find((file) => img.name === file.name && img.size === file.size);

    if (isFileAdded) return;
    if (images.value.length === 3) {
      images.value.shift();
    }
    images.value.push(img);
  });
});
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-product-comments-attached-imgs {
  display: flex;
  background: $grey-4;
  border-radius: 20px 20px 0 0;
  padding: 0 16px;
  margin-bottom: -1px;

  &__item {
    position: relative;
    padding-top: 16px;
    padding-bottom: 16px;

    &:not(:last-child) {
      margin-right: 12px;
    }
  }

  &__item-remove {
    width: 16px;
    height: 16px;
    cursor: pointer;
    position: absolute;
    top: 22px;
    right: 6px;
    background: rgba(0,0,0,.4);
    border-radius: 100px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__image {
    width: 70px;
    height: 70px;
    object-fit: contain;
    border-radius: 2px;
    overflow: hidden;
  }
}
</style>
